export default __webpack_public_path__ + "static/media/edit-pen.a9ec448a.svg";